/**
 * Security policy wire ⇄ domain mappers.
 *
 * The security-service `SecurityPolicyResponse` is a nested snake_case object
 * (`password_policy.min_length`, …) that maps 1:1 to the camelCase
 * `SecurityPolicy` domain shape, so the generic deep converters handle both
 * directions without per-field fixups.
 */

import { toCamelDeep, toSnakeDeep } from '@/services/http/caseMap'
import type {
  SecurityPolicy,
  UpdateSecurityPolicyInput,
} from '@/types/securityPolicy.types'

export function mapSecurityPolicyFromApi(raw: Record<string, unknown>): SecurityPolicy {
  return toCamelDeep<SecurityPolicy>(raw)
}

export function mapUpdateToApi(patch: UpdateSecurityPolicyInput): Record<string, unknown> {
  const body: Record<string, unknown> = {}
  if (patch.passwordPolicy !== undefined) {
    body.password_policy = toSnakeDeep(patch.passwordPolicy)
  }
  if (patch.sessionPolicy !== undefined) {
    body.session_policy = toSnakeDeep(patch.sessionPolicy)
  }
  if (patch.loginPolicy !== undefined) {
    body.login_policy = toSnakeDeep(patch.loginPolicy)
  }
  return body
}
